import React, {Fragment} from 'react';
import {Button, Checkbox, Col, Icon, Row} from "antd";
import {translate} from "react-i18next";
import UpdatedStatusGetter from "../../updated-status-getter";
import {EL_MODE_CREATE, getDataImportStatusTranslation} from "../constants";
import {MARGIN_LG, SPAN_FULL} from "../../../styles/constants";

const ELLoadData = ({
                      t,
                      mode,
                      disabled,
                      onDataSubmit,
                      dataImportReport,
                      isDataImportPending,
                      dataImportStatus,
                      getImportStatus,
                      dstDataflow,
                      publishDf,
                      transcodeDf,
                      onPublishDfChange,
                      onTranscodeDfChange
                    }) => {
  return (
    <Fragment>
      {mode === EL_MODE_CREATE && (
        <Row type="flex" justify="center" gutter={8} style={{marginBottom: 16}}>
          <Col>
            {t('components.easyLoading.steps.load.body.publishDataflow.title')}:
          </Col>
          <Col>
            <Checkbox
              checked={publishDf}
              onChange={e => onPublishDfChange(e.target.checked)}
              disabled={disabled}
            />
          </Col>
        </Row>
      )}
      <Row type="flex" justify="center" gutter={8} style={{marginBottom: 16}}>
        <Col>
          {t('components.easyLoading.steps.load.body.transcodeDataflow.title')}:
        </Col>
        <Col>
          <Checkbox
            checked={transcodeDf}
            onChange={e => onTranscodeDfChange(e.target.checked)}
            disabled={disabled}
          />
        </Col>
      </Row>
      <Row type="flex" justify="center">
        <Col>
          <Button
            type="primary"
            onClick={onDataSubmit}
            disabled={disabled}
          >
            {t('components.easyLoading.steps.load.body.loadData.title')}
            {isDataImportPending && (
              <Icon type="loading"/>
            )}
          </Button>
        </Col>
      </Row>
      <Row type="flex" style={{marginTop: dataImportStatus ? MARGIN_LG : 0}}>
        <Col span={SPAN_FULL}>
          <UpdatedStatusGetter
            enabled={isDataImportPending}
            callback={getImportStatus}
            callbackParam={dstDataflow}
            status={dataImportStatus}
            getStepLabel={step => getDataImportStatusTranslation(t)[step]}
            fishedWithError={!isDataImportPending && !dataImportReport}
          />
        </Col>
      </Row>
    </Fragment>
  )
};

export default translate()(ELLoadData);


// WEBPACK FOOTER //
// ./src/components/easy-loading/load-step/LoadData.jsx